import { render, staticRenderFns } from "./CloseVoting.vue?vue&type=template&id=408a83d7"
import script from "./CloseVoting.vue?vue&type=script&lang=js"
export * from "./CloseVoting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports